import React from 'react';
//import CompanyLogo from '../CompanyLogo/CompanyLogo.png';

const PurchaseReturnsPrint = ({ onClose, labelData }) => {
    const containerStyleN = {
        border: 'none',
        padding: '10px',
        width: '94%',
        marginTop: '10px',
        marginLeft: '10px',
        marginRight: '0px',
    };

    const containerStyle = {
        border: '1px solid #000',
        padding: '5px',
        width: '100%',
        marginTop: '5px',
        marginLeft: '0px',
        marginRight: '5px',
    };

    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        fontFamily: 'Arial',

    };

    const cellStyle = {
        border: '1px solid #000',
        padding: '0px',
    };

    const cellStyleN = {
        border: 'none',
        padding: '0px',
    };

    const cellStyleN1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: 'none',
        borderRight: 'none',
    };

    const cellStyleP = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleP1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        padding: '0px',
    };

    const cellStyleL = {
        borderBottom: 'none',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const cellStyleL1 = {
        borderBottom: '1px solid black',
        borderTop: 'none',
        borderLeft: '1px solid black',
        borderRight: 'none',
        padding: '0px',
    };

    const headerStyle = {
        color: 'blue',
        fontStyle: 'italic',
        fontFamily: 'Newtown, sans-serif',
        textAlign: 'center',
    };

    const labelStyle = {
        marginTop: '5px',
        fontFamily: 'Arial',
        fontSize: '12px',
        marginRight: '5px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + ' ' + units[num % 10];
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred ' + convert(num % 100).trim();
            if (num < 100000) return (convert(Math.floor(num / 1000)) + ' Thousand ' + convert(num % 1000)).trim();
            if (num < 1000000) return (convert(Math.floor(num / 100000)) + ' Lakh ' + convert(num % 100000)).trim();
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rupees {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paise Only</p>}
            </div>
        );
    };
    const cellStyleNew = {
        border: '1px solid #000',
        padding: '0px',
        // marginTop: '15px',
        // height: '20px'
        marginTop: '10px',
        //height: '10px'
    };
 
    return (
        <div style={containerStyleN}>
            {labelData && (
                <>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                            {/* Logo Section */}
                            {/* <div style={{ width: '50%', textAlign: 'left' }}>
                                <img
                                    src={CompanyLogo}
                                    alt="Company Logo"
                                    style={{ maxHeight: '40px', width: 'auto', height: 'auto' }}
                                />
                            </div> */}

                            {/* Company Details Section */}
                            <div style={{ width: '50%', textAlign: 'left', fontSize: '10px', lineHeight: '1.5', marginLeft: '2%' }}>
                                <div style={{ fontWeight: 'normal' }}>
                                    {labelData.PurchaseReturnPrint.CompanyName}
                                </div>
                                <div style={{ fontWeight: 'normal' }}>
                                    {labelData.PurchaseReturnPrint.CompanyAddressLine}
                                </div>
                                <div style={{ fontWeight: 'normal' }}>
                                    Contact: {labelData.PurchaseReturnPrint.CompanyContactNumber1}
                                </div>
                                <div style={{ fontWeight: 'normal' }}>
                                    Email: {labelData.PurchaseReturnPrint.CompanyEmail}
                                </div>
                            </div>
                        </div>


                        <h5 style={{
                            textAlign: 'center',
                            marginTop: '1px',
                            marginBottom: '0px',
                            border: '1px solid black'
                        }}>
                            DEBIT NOTE
                        </h5>

                    </div>

                    <table style={tableStyle}>
                        <tbody>
                            <tr>

                                <td style={{ ...cellStyle, width: '59.40%', textAlign: 'left', maxHeight: '15%' }}>
                                    <h6 style={{ textAlign: 'left', marginTop: '15px', marginBottom: '0px', marginLeft: '10px', marginRight: '10px' }}>CUSTOMER NAME & ADDRESS</h6>
                                    <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px' }}>{labelData.PurchaseReturnPrint.SupplierName}</h6>
                                    {labelData.PurchaseReturnPrint.SupplierAddress ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.SupplierAddress} </h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden' }}>Customer Address: Not Available</h6>
                                    )}
                                    <br></br>
                                    {labelData.PurchaseReturnPrint.SupplierGSTNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal' }}> GST NO:{labelData.PurchaseReturnPrint.SupplierGSTNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Not Available</h6>
                                    )}

                                    {labelData.PurchaseReturnPrint.SupplierContactNumber ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal' }}>TEL : {labelData.PurchaseReturnPrint.SupplierContactNumber}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Contact Number: Not Available</h6>
                                    )}
                                    {labelData.PurchaseReturnPrint.SupplierEmail ? (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', fontWeight: 'normal' }}>Email : {labelData.PurchaseReturnPrint.SupplierEmail}</h6>
                                    ) : (
                                        <h6 style={{ textAlign: 'left', marginTop: '0', marginBottom: '0px', marginLeft: '5%', marginRight: '10px', visibility: 'hidden', fontWeight: 'normal' }}>Supplier Email: Not Available</h6>
                                    )}
                                    <br></br>
                                </td>

                                <td style={{ ...cellStyle, width: '40%', textAlign: 'right' }}>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginBottom: '0px', marginTop: '-15px' }}>
                                        <h6 style={{ margin: '5px 10px 0 0', display: 'inline-block' }}>
                                            Debit Bill No <span style={{ marginLeft: '12px' }}>:</span> {labelData.PurchaseReturnPrint.PurchaseReturnBillNumber}
                                        </h6>
                                    </div>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginTop: '5px' }}>
                                        <h6 style={{ margin: '0 10px 0 0', display: 'inline-block' }}>
                                          Debit Bill Date <span style={{ marginLeft: '3px' }}>:</span> {new Date(labelData.PurchaseReturnPrint.PurchaseReturnBillDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </h6>
                                    </div>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginBottom: '0px'}}>
                                        <h6 style={{ margin: '5px 10px 0 0', display: 'inline-block' }}>
                                            Purchase Bill No <span style={{ marginLeft: '12px' }}>:</span> {labelData.PurchaseReturnPrint.PurchaseBillNumber}
                                        </h6>
                                    </div>
                                    <div style={{ textAlign: 'left', marginLeft: '5px', marginTop: '5px' }}>
                                        <h6 style={{ margin: '0 10px 0 0', display: 'inline-block' }}>
                                            Purchase  Date <span style={{ marginLeft: '3px' }}>:</span> {new Date(labelData.PurchaseReturnPrint.PurchaseBillDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </h6>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                    <table style={tableStyle}>

                        <table style={tableStyle}>
                            <thead>
                                <tr>

                                    <td style={{ ...cellStyle, width: '4%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>HSN</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '34%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>ItemCode / Description</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '4%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>QTY</h6>
                                    </td>

                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>UOM</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Rate</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Amount</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '7%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>GST %</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>CGST</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>SGST</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>IGST</h6>
                                    </td>
                                    <td style={{ ...cellStyle, width: '5%' }}>
                                        <h6 style={{ marginTop: '5px', marginBottom: '2px' }}>Total</h6>
                                    </td>

                                </tr>
                            </thead>
                            <tbody>
                                {labelData && labelData.PurchaseReturnItemsPrint.map((record, index) => {
                                    const isLastRecord = index === labelData.PurchaseReturnItemsPrint.length - 1;
                                    const isFirstRecord = index === 0;

                                    return (
                                        <tr key={index} style={{ height: '20px' }}>

                                            <td style={{ ...cellStyleP, width: '10%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <div style={{ marginLeft: '5px' }}>
                                                    <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                        {record.HSNCode}
                                                    </label>
                                                </div>
                                            </td>
                                            <td style={{ ...cellStyleP, width: '34%', height: '20px', textAlign: 'left', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <div style={{ marginLeft: '5px' }}>
                                                    <label style={{
                                                        marginTop: '5px',
                                                        fontFamily: 'Arial',
                                                        fontSize: '9px',
                                                        textAlign: 'left',
                                                        wordWrap: 'break-word',
                                                        whiteSpace: 'normal'
                                                    }}>
                                                        {record.ItemName}
                                                    </label>
                                                </div>
                                            </td>
                                            <td style={{ ...cellStyleP, width: '10%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <div style={{ marginLeft: '5px' }}>
                                                    <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                        {record.Quantity !== 0 ? record.Quantity : ''}
                                                    </label>
                                                </div>
                                            </td>

                                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.UOM}
                                                </label>
                                            </td>
                                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.Rate !== 0 ? record.Rate : ''}
                                                </label>
                                            </td>
                                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'center', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.Amount !== 0 ? record.Amount : ''}
                                                </label>
                                            </td>

                                            <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.GSTRate !== 0 ? record.GSTRate : ''}
                                                </label>
                                            </td>

                                            <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.CGSTAmount !== 0 ? record.CGSTAmount : ''}
                                                </label>
                                            </td>

                                            <td style={{ ...cellStyleP, width: '6%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.SGSTAmount !== 0 ? record.SGSTAmount : ''}
                                                </label>
                                            </td>

                                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.IGSTAmount !== 0 ? record.IGSTAmount : ''}
                                                </label>
                                            </td>
                                            <td style={{ ...cellStyleP, width: '5%', height: '20px', textAlign: 'right', borderBottom: isLastRecord ? '1px solid black' : 'none' }}>
                                                <label style={{ ...labelStyle, fontSize: '9px' }}>
                                                    {record.TotalAmount !== 0 ? record.TotalAmount : ''}
                                                </label>
                                            </td>

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <table style={tableStyle}>
                            <tbody>
                                <tr>

                                    {/* <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-105px', maxHeight: '20%', width: '72%' }}> */}
                                    <td style={{ ...cellStyle, textAlign: 'left', marginTop: '-105px', maxHeight: '20%', width: '64.90%' }}>
                                        <h6 style={{ marginRight: '10px', marginTop: '-10px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-13px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}></h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-12px', marginLeft: '20px', fontFamily: 'arial', fontWeight: 'normal' }}></h6>
                                        <div style={{ textAlign: 'center', marginTop: '-17%', marginLeft: '10px' }}>
                                        </div>
                                    </td>

                                    {/* <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '17%' }}> */}
                                    <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '18.80%' }}>
                                        <br></br>
                                        <h6 style={{ marginRight: '10px', marginTop: '-10px', fontFamily: 'arial', fontWeight: 'normal' }}>Net Value</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>CGST Amount</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>SGST Amount</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>IGST Amount</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Round Off</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>Grand Total</h6>


                                    </td>

                                    {/* <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '30%', width: '11%' }}> */}
                                    <td style={{ ...cellStyle, textAlign: 'right', columnSpan: 1, maxHeight: '20%', width: '25%' }}>
                                        <br></br>
                                        <h6 style={{ marginRight: '10px', marginTop: '-5px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.TotalAmount.toFixed(2)}</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.CGSTAmount.toFixed(2)}</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.SGSTAmount.toFixed(2)}</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.IGSTAmount.toFixed(2)}</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.RoundOff.toFixed(2)}</h6>
                                        <h6 style={{ marginRight: '10px', marginTop: '-15px', fontFamily: 'arial', fontWeight: 'normal' }}>{labelData.PurchaseReturnPrint.GrandTotal.toFixed(2)}</h6>

                                    </td>

                                </tr>

                            </tbody>
                        </table>
                        <table style={tableStyle}>
                            <tbody >
                                <tr>

                                    <td style={{ ...cellStyleNew, textAlign: 'left', height: '20px', width: '70%' }}>
                                        <h6 style={{ marginRight: '10px', marginTop: '15px', marginLeft: '10px' }}><AmountInWords amount={labelData.PurchaseReturnPrint.GrandTotal} /></h6>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table style={tableStyle}>
                            <tbody>
                                <tr>
                                    <td colSpan="13" style={{ textAlign: 'right', border: '1px solid black', padding: '5px', fontSize: '10px' }}>
                                        For  {labelData.PurchaseReturnPrint.CompanyName}
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        <br></br>
                                        AUTHORIZED SIGNATORY
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </table>

                </>
            )
            }
            <style>
                {`
                    @media print {
                        @page {
                            margin: 0;
                        }
                        body {
                            margin: 5px;
                        }
                    }
                `}
            </style>
        </div >
    );
};

export default PurchaseReturnsPrint;
